import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../../Components/Modal/modal';
import './employeeAddAward.scss';
import {
  CANCEL_TEXT,
  SAVE,
  SKILL_CERT_PROFILE,
} from '../../../../Constants/strings';
import CommonTextField from '../../../../Components/TextField/textField';
import SearchDropdown from '../../../../Components/Dropdown/dropdown';
import { addAward } from '../../../../Api/request/achievements';
import UseAxios from '../../../../Api/http/http';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';
import { STATUS_CODES } from '../../../../Api/resources/statusCodes';

const AddAward = ({ modalOpen, handleClose, userId, updatedData }) => {
  const [addNameValue, setAddNameValue] = useState('');
  const [descriptionValue, setDescriptionValue] = useState('');
  const [selectedYear, setSelectedYear] = useState(null);
  const [years, setYears] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const { snackbarOpen } = useSnackbar();

  useEffect(() => {
    const getCurrentYear = () => new Date().getFullYear();
    const yearsArray = Array.from(
      { length: getCurrentYear() - 2010 + 1 },
      (year, index) => ({
        id: index + 1,
        name: String(2010 + index),
      }),
    );
    setYears(yearsArray);
  }, []);

  useEffect(() => {
    setIsDisabled(
      !(addNameValue.trim() && descriptionValue.trim() && selectedYear),
    );
  }, [addNameValue, descriptionValue, selectedYear]);

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length <= 50) {
      setAddNameValue(newValue);
    }
  };

  const handleDescriptionChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length <= 250) {
      setDescriptionValue(newValue);
    }
  };

  const handleCloseResetValues = () => {
    setAddNameValue('');
    setDescriptionValue('');
    setSelectedYear(null);
    handleClose();
    setIsDisabled(true);
  };

  const handleSubmit = async () => {
    try {
      const response = await UseAxios(
        addAward(userId, addNameValue, descriptionValue, selectedYear.name),
      );

      if (response.data.status === STATUS_CODES.SUCCESS) {
        handleCloseResetValues();
        updatedData();
        snackbarOpen(SKILL_CERT_PROFILE.ADD_SUCCESS_MSG, 'success');
      }
    } catch (error) {
      console.error('Error adding award:', error);
      snackbarOpen(SKILL_CERT_PROFILE.ADD_TRY_AGAIN, 'warning');
    }
  };

  return (
    <FormDialog
      open={modalOpen}
      title={SKILL_CERT_PROFILE.AWARD_TITLE}
      dialogPaperCss="add-award-paper"
      dialogCss="add-award-dialog"
      dialogBodycontent={
        <div className="add-award-dialog-body">
          <div className="add-award-dropdown">
            <div className="add-award-name-dropdown">
              <CommonTextField
                textCss="add-award-name"
                label={SKILL_CERT_PROFILE.AWARD_NAME}
                value={addNameValue}
                onChange={handleInputChange}
                placeholder={SKILL_CERT_PROFILE.AWARD_NAME_PLACEHOLDER}
                autoFocus
                size="small"
                id="add-award-name-text"
              />
            </div>
            <div className="add-award-year-dropdown">
              <SearchDropdown
                options={years}
                label=""
                placeholder={SKILL_CERT_PROFILE.AWARD_YEAR_PLACEHOLDER}
                value={selectedYear}
                onChange={(event) => setSelectedYear(event.target.value)}
                searchBox={false}
                id="award-year-dropdown"
                dropdownCss="add-award-year"
              />
            </div>
          </div>
          <CommonTextField
            textCss="add-award-description"
            label={SKILL_CERT_PROFILE.AWARD_DESCRIPTION}
            value={descriptionValue}
            onChange={handleDescriptionChange}
            placeholder={SKILL_CERT_PROFILE.AWARD_DESC_PLACEHOLDER}
            size="small"
            id="add-description-text"
            multiline
            rows={4}
          />
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId="add-award-cancel-btn"
      button1Action={handleCloseResetValues}
      button2={SAVE}
      submitButtonId="add-award-add-btn"
      button2Action={handleSubmit}
      button2Disabled={isDisabled}
    />
  );
};

AddAward.propTypes = {
  userId: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  updatedData: PropTypes.func,
};

export default AddAward;
